import api from '../api';

export const reportService = {
    getStudentReport: async (studentId) => {
        try {
            const response = await api.get(`/reports/students/${studentId}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching student report:', error);
            throw error;
        }
    },

    getTeacherCoursesReportSummary: async (teacherId) => {
        try {
            const response = await api.get(`/reports/teachers/${teacherId}/courses`);
            return response.data;
        } catch (error) {
            console.error('Error fetching teacher courses report summary:', error);
            throw error;
        }
    },

    getTeacherStudentsReportSummary: async (teacherId) => {
        try {
            const response = await api.get(`/reports/teachers/${teacherId}/students`);
            return response.data;
        } catch (error) {
            console.error('Error fetching teacher students report summary:', error);
            throw error;
        }
    },

    getCourseReport: async (courseId) => {
        try {
            const response = await api.get(`/reports/courses/${courseId}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching course report:', error);
            throw error;
        }
    },

    getPeriodReport: async (periodId) => {
        try {
            const response = await api.get(`/reports/periods/${periodId}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching period report:', error);
            throw error;
        }
    },

    // Get quiz report details
    getQuizReport: async (quizId) => {
        try {
            const response = await api.get(`/reports/quizzes/${quizId}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching quiz report:', error);
            throw error;
        }
    },
    // Get quiz report details
    getStudentQuizReport: async (studentId, quizId) => {
        try {
            const response = await api.get(`/reports/students/${studentId}/quizzes/${quizId}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching quiz report:', error);
            throw error;
        }
    },

    getTeacherPerformanceMetrics: async (teacherId) => {
        try {
            const response = await api.get(`/reports/teachers/${teacherId}/performance`);
            return response.data;
        } catch (error) {
            console.error('Error fetching teacher performance metrics:', error);
            throw error;
        }
    },
};

export default reportService;